import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (email, password) =>
    api.post("/api/auth/login", { email, password }),
  register: (email, password, name) =>
    api.post("/api/auth/register", { email, password, name }),
  me: () => api.get("/api/auth/me"),
};

export const recipeAPI = {
  generate: (ingredients, language = "fr") =>
    api.post("/api/recipes/generate", { ingredients, language }),
  popularIngredients: (language = "fr") => api.get(`/api/popular-ingredients?language=${language}`),
};

export const favoritesAPI = {
  list: () => api.get("/api/favorites"),
  add: (recipe) =>
    api.post("/api/favorites", {
      recipe_id: recipe.id,
      title: recipe.title,
      description: recipe.description || "",
      ingredients: recipe.ingredients || [],
      instructions: recipe.instructions || [],
      prep_time: recipe.prep_time || "",
      cook_time: recipe.cook_time || "",
      servings: recipe.servings || 4,
      dietary_tags: recipe.dietary_tags || [],
      image_base64: recipe.image_base64 || "",
    }),
  remove: (id) => api.delete(`/api/favorites/${id}`),
};

export const historyAPI = {
  list: () => api.get("/api/history"),
};

export const pricingAPI = {
  get: () => api.get("/api/pricing"),
  checkout: (packageId, originUrl) =>
    api.post("/api/checkout/create", {
      package_id: packageId,
      origin_url: originUrl,
      allow_promotion_codes: true,
    }),
};

export default api;
